import { optionsToStrategy } from '@/common/utils/optionsToStrategy'

export const options = [
  { label: 'Nenhum', value: 'none' },
  { label: 'Por transação', value: 'per_transaction' },
  { label: 'Por lote', value: 'per_bill' },
]

export const strategy = optionsToStrategy(options)
